import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import paths from '../../utils/paths'

export default function ProtectedMcatRoute(): JSX.Element {
  const { authInformation, user } = useAuth()

  if (!user) {
    return <Navigate to={paths.mcatLogin} replace />
  }

  if (!authInformation?.isMcatUser) {
    return <Navigate to={paths.unauthorized} replace />
  }

  return <Outlet />
}
